import React from 'react';
import PropTypes from 'prop-types';

const Avatar = ({ thumbnailUrl }) => {
  return (
    <div className="avatar-container">
      <img src={thumbnailUrl} aria-hidden="true" />
    </div>
  );
};

Avatar.propTypes = {
  thumbnailUrl: PropTypes.string.isRequired,
};

export default Avatar;
